@if ((messageCount$ | async); as messageCount) {
  <button
    mat-icon-button [matBadge]="messageCount" matBadgeSize="small" matBadgePosition="below"
    matBadgeOverlap="true" matBadgeColor="warn" (click)='btnClick($event)'>
    <mat-icon>mail</mat-icon>
  </button>
}
